import React from 'react';
import NavigationStack from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Index from './pages/IndexPage';
import Difference from './pages/Difference';
import Team from './pages/Team';
import GalleryPage from './pages/GalleryPage';
import Testimonials from './pages/Testimonials';
import LatestNews from './pages/LatestNews';
import LatestNewsDetail from './pages/LatestNews/detail';
import BuildingProcess from './pages/BuildingProcess';
import DesignCenter from './pages/DesignCenter';
import Financing from './pages/Financing';
import EnergySavings from './pages/EnergySavings';
import WhyBuyNew from './pages/WhyBuyNew';
import Faq from './pages/Faq';
import ContactUs from './pages/ContactUs';
import ContactUsThankYou from './pages/ContactUs/ContactUsThankYou';
import CustomerCare from './pages/CustomerCare';
import ServiceRequest from './pages/ServiceRequest';
import ServiceRequestThankYou from './pages/ServiceRequest/ServiceRequestThankYou';
// import Careers from './Careers';
import Root from './Root';
import NoRoute from './pages/NoRoute';


import PlansList from './pages/Plans/CardsList';
// import CardsListHorizontal from './Homes/CardsList';
import CardsListVertical from './pages/HomesOriginal/CardsList';
import HomeDetail from './pages/Homes/HomeDetail';
import PlanDetail from './pages/Plans/PlanDetail';
import { CommunityDetail, CommunitiesList } from './pages/Communities';
import './global.scss';

import configuration from './configuration';


ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <NavigationStack
      stack="RegionalSimple"
      routes={[
        // { name: 'index', exact: true, path: '/', component: Index },
        { name: 'difference', exact: true, path: '/difference', component: Difference },
        { name: 'team', exact: true, path: '/team', component: Team },
        { name: 'gallery', exact: true, path: '/gallery', component: GalleryPage },
        { name: 'testimonials', exact: true, path: '/testimonials', component: Testimonials },
        { name: 'latest-news', exact: true, path: '/latest-news', component: LatestNews },
        { name: 'latest-news', exact: true, path: '/latest-news/:blogpostTitle', component: LatestNewsDetail, sitemapType: 'blogpost' },
        { name: 'building-process', exact: true, path: '/building-process', component: BuildingProcess },
        { name: 'design-center', exact: true, path: '/design-center', component: DesignCenter },
        { name: 'financing', exact: true, path: '/financing', component: Financing },
        { name: 'energy-savings', exact: true, path: '/energy-savings', component: EnergySavings },
        { name: 'why-buy-new', exact: true, path: '/why-buy-new', component: WhyBuyNew },
        { name: 'faq', exact: true, path: '/faq', component: Faq },
        { name: 'contact-us', exact: true, path: '/contact-us', component: ContactUs },
        { name: 'contact-us-thank-you', exact: true, path: '/contact-us/thank-you', component: ContactUsThankYou, sitemapIgnore: true },
        { name: 'customer-care', exact: true, path: '/customer-care', component: CustomerCare },
        { name: 'service-request', exact: true, path: '/service-request', component: ServiceRequest },
        { name: 'service-request-thank-you', exact: true, path: '/service-request/thank-you', component: ServiceRequestThankYou, sitemapIgnore: true },
        // { name: 'careers', exact: true, path: '/careers', component: Careers },
      ]}
      components={[
        { override: 'Root', component: Root },
        { override: 'Header', component: Header },
        { override: 'Index', component: Index },
        { override: 'HomesList', component: CardsListVertical },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'PlansList', component: PlansList },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'CommunitiesList', component: CommunitiesList },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'NoRoute', component: NoRoute },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js